import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../core/helpers/default';

const name = 'reports';

const reducersKeys = {
  fetchReportsRequest: 'fetchReportsRequest',
  fetchReportsSuccess: 'fetchReportsSuccess',
  fetchReportsFailure: 'fetchReportsFailure',
  fetchReportRequest: 'fetchReportRequest',
  fetchReportSuccess: 'fetchReportSuccess',
  fetchReportFailure: 'fetchReportFailure',
  setSelectedReport: 'setSelectedReport',
};

const initialState = {
  reports: [],
  selectedReport: null,
  reportEmbedUrl: null,
  loading: false,
  error: null,
};

const reportsSlice = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.fetchReportsRequest]: (state) => {
      state.selectedReport = null;
      state.loading = true;
      state.error = null;
    },
    [reducersKeys.fetchReportsSuccess]: (state, { payload }) => {
      state.loading = false;
      state.reports = payload.reports;
      // Auto-select first report
      if (payload.reports.length > 0) {
        state.selectedReport = payload.reports[0];
      }
    },
    [reducersKeys.fetchReportsFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    [reducersKeys.fetchReportRequest]: (state) => {
      state.error = null;
    },
    [reducersKeys.fetchReportSuccess]: (state, { payload }) => {
      state.reportEmbedUrl = payload.embedUrl;
    },
    [reducersKeys.fetchReportFailure]: (state, { payload }) => {
      state.error = payload;
    },
    [reducersKeys.setSelectedReport]: (state, { payload }) => {
      state.selectedReport = payload;
    },
  },
});

export const reportsReducer = createReducerNames(name, reducersKeys);
export const { actions } = reportsSlice;

export default reportsSlice.reducer;
